<template>
  <div id="reposicionRepresentacion">
    <v-layout wrap>
      <v-flex xs3>
        <v-container>
          <v-select v-model="tipoGasto" :items="tipos_gastos" item-text="descripcion" item-value="id"
            label="Seleccionar tipo de gastos"></v-select>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateStart" :close-on-content-click="false" v-model="menuDateStart" :nudge-right="40"
            :return-value.sync="menuDateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaInicio" label="Fecha Inicio" readonly></v-text-field>
            <v-date-picker v-model="fechaInicio" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateStart = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateStart.save(fechaInicio)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateEnd" :close-on-content-click="false" v-model="menuDateEnd" :nudge-right="40"
            :return-value.sync="menuDateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaFin" label="Fecha Fin" readonly></v-text-field>
            <v-date-picker v-model="fechaFin" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateEnd = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateEnd.save(fechaFin)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
    </v-layout>
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Reposiciones</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="newSol()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Comprobacion</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="solicitudes" :loading="loading" :search="search" class="elevation-1"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" :items-per-page="10">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td class="text-xs-center">{{ item.idsolicitud_comprobacion_representacion }}</td>
            <td class="text-xs-center">{{ mapTipoGasto(item.idsolicitud_gasto_representacion.tipo_gasto) }}</td>
            <td class="text-xs-center">{{ mapTipoPago(item.idsolicitud_gasto_representacion.tipo_pago) }}</td>
            <td class="text-xs-center">{{ item.no_facturas }}</td>
            <td class="text-xs-center">{{ formatCurrency(item.importe_total) }}</td>
            <td class="text-xs-center">{{ item.idcat_estatus.estatus }}</td>
            <td class="text-xs-center">{{ formatDate(item.fecha_creacion) }}</td>
            <td class="text-xs-center">

              <v-tooltip bottom>
                <v-btn slot="activator" small icon @click="showDetailRep(item.idsolicitud_comprobacion_representacion)">
                  <v-icon>description</v-icon>
                </v-btn>
                <span>Ver Detalles</span>
              </v-tooltip>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <div class="text-xs-center">No hay solicitudes registradas.</div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogNewReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="showDetail ? confirmClose() : confirmCloseReq = true">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title> <span>{{ 'Comprobacion de Gastos'
              }}</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat v-if="!showDetail" :loading="loading" @click="checkQuestionReq()">{{ 'Guardar'
              }}</v-btn>
            <v-tooltip v-if="showDetail" left>
              <v-btn slot="activator" :loading="loading" icon @click="print()">
                <v-icon>local_printshop</v-icon>
              </v-btn>
              <span>Imprimir</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout wrap class="no-gutters">
              <!-- Columna 1 -->
              <v-flex xs12 sm4 md4>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Solicitud Gastos Representacion
                </div>
                <v-select v-model="sol_gastos" :items="solicitudes_gastos" :item-text="formatSolicitud"
                  item-value="idsolicitud_gasto_representacion" label="Seleccionar Solicitud" :disabled="showDetail"
                  @change="onSeleccionarSolicitud"></v-select>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Tipo de gastos
                </div>
                <v-radio-group v-model="solicitud.tipo_gasto" :mandatory="false" disabled
                  @input="$v.solicitud.tipo_gasto.$touch()" @blur="$v.solicitud.tipo_gasto.$touch()">
                  <v-radio label="Gastos de representación" color="primary" value="representacion" />
                  <v-radio label="Gastos de atención al personal" color="primary" value="atencion_personal" />
                  <v-radio-group v-if="solicitud.tipo_gasto == 'atencion_personal'" v-model="solicitud.tipo_atencion"
                    @input="$v.solicitud.tipo_atencion.$touch()" @blur="$v.solicitud.tipo_atencion.$touch()"
                    :mandatory="false" class="ml-5 mt-neg">
                    <div slot="label"><strong>Tipo de atencion</strong></div>
                    <v-radio label="Comida de Trabajo" value="comidas_trabajo" />
                    <v-radio label="Reuniones de Integración" value="reuniones_integracion" />
                  </v-radio-group>
                </v-radio-group>

                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Tipo de pago
                </div>
                <v-radio-group v-model="solicitud.tipo_pago" :mandatory="false" disabled
                  @input="$v.solicitud.tipo_pago.$touch()" @blur="$v.solicitud.tipo_gasto.$touch()">
                  <v-radio label="Transferencia" color="primary" value="transferencia" />
                  <v-radio label="Cheque" color="primary" value="cheque" />
                </v-radio-group>

                <br>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Datos de depósito
                </div>
                <!-- Banco -->
                <v-text-field class="deposito-field" v-model="solicitud.banco" disabled
                  @input="$v.solicitud.banco.$touch()" @blur="$v.solicitud.banco.$touch()" label="Banco" />

                <!-- No. Cuenta -->
                <v-text-field class="deposito-field" v-model="solicitud.cuenta" disabled
                  @input="$v.solicitud.cuenta.$touch()" @blur="$v.solicitud.cuenta.$touch()" label="No. Cuenta" />

                <!-- No. Tarjeta -->
                <v-text-field class="deposito-field" v-model="solicitud.tarjeta" disabled
                  @input="$v.solicitud.tarjeta.$touch()" @blur="$v.solicitud.tarjeta.$touch()" label="No. Tarjeta" />

                <!-- Referencia Interbancaria -->
                <v-text-field class="deposito-field" v-model="solicitud.clabe" disabled
                  @input="$v.solicitud.clabe.$touch()" @blur="$v.solicitud.clabe.$touch()"
                  label="Referencia Interbancaria" />

              </v-flex>

              <!-- Columna 2 -->
              <v-flex xs12 sm4 md4>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Responsable
                </div>
                <v-text-field v-model="solicitud.nombre" disabled @input="$v.solicitud.nombre.$touch()"
                  @blur="$v.solicitud.nombre.$touch()" label="Nombre" />
                <v-select v-model="solicitud.puesto" :error-messages="puestoErrors" :items="catalogos.puestos" disabled
                  :item-text="centroText" item-value="idcat_puesto" label="Puesto" @input="$v.solicitud.puesto.$touch()"
                  @blur="$v.solicitud.puesto.$touch()" />
                <v-select v-model="solicitud.departamento" disabled :items="catalogos.departamentos"
                  :item-text="centroText" item-value="idcat_departamento" label="Departamento"
                  @input="$v.solicitud.departamento.$touch()" @blur="$v.solicitud.departamento.$touch()" />
                <v-select v-model="solicitud.direccion" :items="catalogos.direcciones" disabled :item-text="centroText"
                  item-value="idcat_direccion" label="Plaza" @input="$v.solicitud.direccion.$touch()"
                  @blur="$v.solicitud.direccion.$touch()" />
                <v-select v-model="solicitud.empresa" :items="catalogos.empresas" disabled :item-text="centroText"
                  item-value="idcat_empresa" label="Empresa" @input="$v.solicitud.empresa.$touch()"
                  @blur="$v.solicitud.departamento.$touch()" />
                <v-select v-model="solicitud.centro" :items="catalogos.centros" disabled :item-text="centroText"
                  item-value="idcat_centro_costo" label="Centro de costos" @input="$v.solicitud.centro.$touch()"
                  @blur="$v.solicitud.centro.$touch()" />
                <v-text-field v-model="solicitud.asistentes" disabled @input="$v.solicitud.asistentes.$touch()"
                  @blur="$v.solicitud.asistentes.$touch()" label="No. Asistentes" type=" number" />

                <h3 class="grey--text firmas-titulo">FIRMAS DE APROBACION</h3><br />
                <v-list three-line dark class="firmas-list">
                  <template v-for="(item, i) in firmas">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                          v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                  </template>
                </v-list>
              </v-flex>

              <!-- Columna 3 -->
              <v-flex xs12 sm4 md4>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Detalle de pago
                </div>
                <v-text-field v-model="solicitud.importe" @input="$v.solicitud.importe.$touch()" disabled
                  @blur="$v.solicitud.importe.$touch()" label="Importe" prefix="$" suffix="MXN" type="number" />
                <v-text-field v-model="facturas.detalle.length" disabled label="No. Facturas" />
                <v-layout wrap>
                  <!-- Botón Agregar -->
                  <v-flex xs12 sm12 md6>
                    <v-btn small block color="blue-grey" :disabled="!enableAdd" class="white--text"
                      @click="dialogNewCom = true">
                      Agregar
                      <v-icon small right dark>add_circle</v-icon>
                    </v-btn>
                  </v-flex>

                  <!-- Botón Mostrar -->
                  <v-flex xs12 sm12 md6>
                    <div class="text-xs-center">
                      <v-menu transition="slide-y-transition" top left offset-y full-width>
                        <v-btn slot="activator" :disabled="facturas.detalle.length == 0" small block color="blue-grey"
                          class="white--text">
                          Mostrar
                          <v-icon small right dark>remove_red_eye</v-icon>
                        </v-btn>
                        <v-list v-if="facturas.detalle.length > 0">
                          <v-list-tile v-for="(fac, idx) in facturas.detalle" :key="idx" @click="showDetailFac(idx)">
                            <v-list-tile-title
                              v-text="catalogos.conceptos.filter(concepto => { return concepto.id == fac.idcat_concepto })[0].descripcion"></v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-flex>

                  <!-- Botón Descargar Todo -->
                  <v-flex xs12>
                    <div class="text-xs-center">
                      <v-btn small color="blue-grey" :disabled="facturas.detalle.length == 0" class="white--text"
                        @click="descargarTodo">
                        DESCARGAR TODO
                        <v-icon small right dark>cloud_download</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>

                  <!-- Subtotal -->
                  <v-flex xs12 sm12 md6>
                    <v-text-field :value="formatMoney(facturas.subtotal)" label="Subtotal" box prefix="$" suffix="MXN"
                      readonly></v-text-field>
                  </v-flex>

                  <!-- IVA -->
                  <v-flex xs12 sm12 md6>
                    <v-text-field :value="formatMoney(facturas.iva)" label="IVA" box prefix="$" suffix="MXN"
                      readonly></v-text-field>
                  </v-flex>
                  <v-text-field :value="formatMoney(facturas.total)" label="Importe por reembolsar" prefix="$"
                    suffix="MXN" box readonly>
                  </v-text-field>
                </v-layout>

                <h3 class="grey--text">RESUMEN</h3><br />
                <v-data-table v-if="facturas" :headers="headersResumen" :items="facturas.detalle" class="elevation-1"
                  hide-actions no-data-text="">
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{ mapTipo(props.item.tipo_gasto) }}</td>
                    <td class="text-xs-right">{{catalogos.conceptos.filter(concepto => {
                      return concepto.id ==
                        props.item.idcat_concepto
                    })[0].descripcion}}</td>
                    <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                    <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                    <td class="text-xs-right">{{ formatCurrency(props.item.subtotal) }}</td>
                    <!-- <td class="text-xs-right">{{ props.item.iva }}</td> > -->
                    <td class="text-xs-right">{{ formatCurrency(props.item.total) }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="alert" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="questionReq" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea guardar la nueva solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveSol()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCloseReq" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Está seguro que desea salir?</v-card-title>
        <v-card-text>
          Va a cerrar esta ventana. Perderá los cambios capturados.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmClose()">Salir</v-btn>
          <v-btn color="green" dark @click="confirmCloseReq = false">Mantenerse en solicitud</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogResumen" max-width="600px">
      <v-card>
        <v-card-title class="headline justify-center">
          Resumen de Tarjetahabientes
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="[
            { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false },
            { text: 'Saldo a pagar', value: 'saldo_a_pagar', sortable: false }
          ]" :items="resumenTarjetahabientes" class="elevation-1" hide-default-footer>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>{{ item.tarjetahabiente }}
                </td>
                <td class="text-xs-center">{{
                  formatCurrency(item.saldo_a_pagar) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResumen = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewCom" :loading="loading" width="500" :persistent="true">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo Comprobante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ solicitud.comprobantes.no_comprobantes + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="solicitud.comprobantes.nueva.tipo_gasto" :error-messages="tipoGastoErrors"
              @change="resetCamposNuevoComprobante" :mandatory="false"
              @input="$v.solicitud.comprobantes.nueva.tipo_gasto.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.tipo_gasto.$touch()">
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.pdf" @click="$refs.pdf.click()">
                  PDF
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="pdf" type="file" @change="readFile('pdf')">
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-btn v-if="gastoDeducible" block round :color="color.xml" @click="$refs.xml.click()">
                  XML
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <v-btn v-else block round :color="color.foto" @click="$refs.foto.click()">
                  FOTO
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="xml" type="file" @change="readFile('xml')">
                <input v-show="false" ref="foto" type="file" @change="readFile('foto')">
              </v-flex>
            </v-layout>
            <br />
            <v-select v-model="solicitud.comprobantes.nueva.concepto" :error-messages="conceptoErrors"
              :items="catalogos.conceptos" @input="$v.solicitud.comprobantes.nueva.concepto.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.concepto.$touch()" item-text="descripcion" item-value="id"
              label="Concepto"></v-select>
            <v-select v-show="!gastoDeducible" v-model="solicitud.comprobantes.nueva.detalleNoDeducible"
              :error-messages="detalleNoDeducibleErrors" :items="catalogos.detallesNoDeducibles"
              @input="$v.solicitud.comprobantes.nueva.detalleNoDeducible.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.detalleNoDeducible.$touch()" item-text="descripcion"
              item-value="idcat_detalle_nodeducible" label="Detalle no deducible"></v-select>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.rfc" :error-messages="rfcErrors"
              @input="$v.solicitud.comprobantes.nueva.rfc.$touch()" @blur="$v.solicitud.comprobantes.nueva.rfc.$touch()"
              label="RFC" :disabled="!gastoNoDeducible" :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.proveedor"
              :error-messages="proveedorErrors" @input="$v.solicitud.comprobantes.nueva.proveedor.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.proveedor.$touch()" label="Proveedor" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.folio"
              :error-messages="folioErrors" @input="$v.solicitud.comprobantes.nueva.folio.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.folio.$touch()" label="Folio" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.uuid" :error-messages="uuidErrors"
              @input="$v.solicitud.comprobantes.nueva.uuid.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.uuid.$touch()" label="UUID" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :value="formatMoney(solicitud.comprobantes.nueva.subtotal)"
              :error-messages="uuidErrors" @input="$v.solicitud.comprobantes.nueva.subtotal.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.subtotal.$touch()" label="Subtotal" prefix="$" suffix="MXN"
              :disabled="!gastoNoDeducible" :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :disabled="!gastoNoDeducible" v-model="solicitud.comprobantes.nueva.iva"
              :error-messages="ivaErrors" @input="$v.solicitud.comprobantes.nueva.iva.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.iva.$touch()" label="IVA" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible && solicitud.comprobantes.nueva.totalIEPS" :disabled="!gastoNoDeducible"
              :value="formatMoney(solicitud.comprobantes.nueva.totalIEPS)" label="IEPS" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :disabled="!gastoNoDeducible"
              v-model="solicitud.comprobantes.nueva.descuento" :error-messages="descuentoErrors"
              @input="$v.solicitud.comprobantes.nueva.descuento.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.descuento.$touch()" label="Descuento" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="!gastoNoDeducible" v-model="solicitud.comprobantes.nueva.total" label="Total"
              :error-messages="totalErrors" @input="$v.solicitud.comprobantes.nueva.total.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.total.$touch()" prefix="$" suffix="MXN"
              :readonly="false"></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat v-show="!loading" color="blue-grey" @click.native="closeNewCom()">Cancelar</v-btn>
          <v-btn dark color="blue-grey" :loading="loading"
            @click.native="!comprobanteInvalidoPorTotales && saveNewCom()"
            :style="comprobanteInvalidoPorTotales ? 'opacity: 0.5; pointer-events: none;' : ''">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetFac" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de Factura</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalleFactura.index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalleFactura.tipo_gasto" :mandatory="false" disabled>
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('pdf')">
                  PDF
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('xml')">
                  XML
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('foto')">
                  Foto
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 v-if="roles.includes('administrador')">
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="abrirActualizarConcepto()">
                  Actualizar Concepto
                  <v-icon right dark>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br />
            <v-text-field v-model="detalleFactura.concepto" class="pt-4" label="Concepto" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.rfc" class="pt-4"
              label="RFC" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.proveedor"
              class="pt-4" label="Proveedor" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.folio" class="pt-4"
              label="Folio" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.subtotal" class="pt-4"
              label="Subtotal" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.descuento"
              class="pt-4" label="Descuento" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-if="detalleFactura.tipo_gasto == 'deducible'" v-model="detalleFactura.iva" class="pt-4"
              label="IVA" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalleFactura.total" class="pt-4" label="Total" prefix="$" suffix="MXN"
              disabled></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="dialogNewRep" flat color="error" @click.native="questionFac = true">Eliminar</v-btn>
          <v-btn flat color="blue-grey" @click.native="closeDetailFac()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionFac" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea eliminar la factura?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionFac = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="removeElement()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogActualizarConcepto" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">Actualizar Concepto</v-card-title>
        <v-card-text>
          <v-select v-model="nuevoConcepto" :items="conceptosDisponibles" item-text="descripcion" item-value="id"
            label="Seleccionar nuevo concepto"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeActualizarConcepto()">Cancelar</v-btn>
          <v-btn color="blue-grey" dark :loading="loading" @click="updateConcepto()">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import services from "@/config/services";
import axios from "axios";
import download from "downloadjs";
import { validationMixin } from "vuelidate";
import {
  decimal,
  maxLength,
  maxValue,
  minValue,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "ReposicionRepresentacion",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      centro: {
        required: requiredIf(function () {
          return true;
        })
      },
      direccion: {
        required: requiredIf(function () {
          return true;
        })
      },
      empresa: {
        required: requiredIf(function () {
          return true;
        })
      },
      departamento: {
        required: requiredIf(function () {
          return true;
        })
      },
      puesto: {
        required: requiredIf(function () {
          return true;
        })
      },
      comprobantes: {
        importe_total: {
          required: requiredIf(function () {
            return true;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        },
        nueva: {
          uuid: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          folio: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          proveedor: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          detalleNoDeducible: {
            required: requiredIf(function () {
              return this.dialogNewCom && !this.gastoDeducible;
            })
          },
          tipo_gasto: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            })
          },
          concepto: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            })
          },
          rfc: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible
            }),
            maxLength: maxLength(13)
          },
          subtotal: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          },
          descuento: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          iva: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          total: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          }
        }
      }
    }
  },
  data() {
    return {
      tipoGasto: "0",
      tipos_gastos: [{
        id: "0",
        descripcion: "Todos"
      }, {
        id: "representacion",
        descripcion: "Representación"
      }, {
        id: "atencion_personal",
        descripcion: "Atención al personal"
      },

      ],
      color: {
        pdf: "",
        xml: "",
        foto: "",
      },
      enableAdd: false,
      idsolicitud_gasto_representacion: null,
      idsolicitud_comprobacion: null,
      showDetail: false,
      questionFac: false,
      dialogNewRep: false,
      dialogNewFac: false,
      dialogDetFac: false,
      dialogDetRep: false,
      detalleFactura: {
        index: "",
        tipo_gasto: null,
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        razon_social: "",
        rfc: "",
        no_factura: "",
        fecha_timbrado: "",
        proveedor: "",
        folio: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: "",
        id_comprobante: null,
        idcat_concepto: null
      },
      headersResumen: [
        {
          text: "TIPO DE GASTO",
          align: "center",
          sortable: false,
          value: "tipo_gasto"
        },
        { text: "CONCEPTO", align: "center", sortable: false, value: "concepto" },
        {
          text: "FECHA DE TIMBRADO",
          align: "center",
          sortable: false,
          value: "fecha_timbrado"
        },
        /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
        {
          text: "SUB TOTAL", align: "center", sortable: false, value: "subtotal"
        },
        // { text: "IVA", align: "center", sortable: false, value: "iva" },
        { text: "TOTAL", align: "center", sortable: false, value: "total" }
      ],
      facturas: {
        total: 0,
        subtotal: 0,
        iva: 0,
        detalle: []
      },
      solicitud: {
        tipo_pago: null,
        comprobantes: {
          importe_total: 0,
          no_comprobantes: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          nueva: {
            tipo_gasto: "deducible",
            pdf: { nombre: "", data: null },
            xml: { nombre: "", data: null },
            foto: { nombre: "", data: null },
            centro: null,
            concepto: "",
            rfc: "",
            proveedor: "",
            folio: "",
            uuid: "",
            no_comprobante: "",
            fecha_timbrado: "",
            subtotal: "",
            descuento: "",
            iva: "",
            total: "",
            totalIEPS: ""
          },
        }
      },
      dialogNewCom: false,
      sol_gastos: null,
      solicitudes_gastos: [],
      firmas: [],
      questionReq: false,
      confirmCloseReq: false,
      msgError: "",
      msgSuccess: "",
      success: false,
      dialogNewReq: false,
      loading: false,
      alert: false,
      search: "",
      solicitudes: [],
      menuDateStart: false,
      menuDateEnd: false,
      fechaInicio: "",
      fechaFin: "",
      dialogResumen: false,
      resumenTarjetahabientes: [],
      pagination: {
        rowsPerPage: 7
      },
      headers: [
        { text: "Id", sortable: false, class: 'text-xs-center' },
        { text: "Tipo de Solicitud", sortable: false, class: 'text-xs-center' },
        { text: "Tipo de Pago", sortable: false, class: 'text-xs-center' },
        { text: "No. Facturas", sortable: false, class: 'text-xs-center' },
        { text: "Importe Total", sortable: false, class: 'text-xs-center' },
        { text: "Estado", sortable: false, class: 'text-xs-center' },
        { text: "Fecha de Registro", sortable: false, class: 'text-xs-center' },
        { text: "Acciones", sortable: false, class: 'text-xs-center' },

      ],
      catalogos: {
        centros: [],
        direcciones: [],
        empresas: [],
        departamentos: [],
        puestos: []
      },
      roles: [],
      dialogActualizarConcepto: false,
      nuevoConcepto: null,
      conceptosDisponibles: []
    };
  },
  computed: {
    gastoDeducible() {
      return (
        this.dialogNewCom &&
        this.solicitud.comprobantes.nueva.tipo_gasto === "deducible"
      );
    },
    gastoNoDeducible() {
      return (
        this.dialogNewCom &&
        this.solicitud.comprobantes.nueva.tipo_gasto === "no_deducible"
      );
    },
    comprobanteInvalidoPorTotales() {
      if (!this.gastoDeducible) {
        return false
      }
      const { subtotal, iva, descuento, total } = this.solicitud.comprobantes.nueva;
      const st = parseFloat(subtotal) || 0;
      const iv = parseFloat(iva) || 0;
      const desc = parseFloat(descuento) || 0;
      const tot = parseFloat(total) || 0;
      return (st + iv - desc).toFixed(2) !== tot.toFixed(2);
    },
    proveedorErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.proveedor.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.proveedor.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    folioErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.folio.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.folio.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    uuidErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.uuid.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.uuid.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    detalleNoDeducibleErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.detalleNoDeducible.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.detalleNoDeducible.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeTotalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.importe_total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.importe_total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.importe_total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.importe_total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.importe_total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tipoGastoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.tipo_gasto.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.tipo_gasto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    conceptoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.concepto.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.concepto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    rfcErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.rfc.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.rfc.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.solicitud.comprobantes.nueva.rfc.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    descuentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.descuento.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.descuento.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.descuento.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.descuento.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.descuento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    ivaErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.iva.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.iva.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.iva.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.iva.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.iva.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    centroErrors() {
      const errors = [];
      if (!this.$v.solicitud.centro.$dirty) return errors;
      !this.$v.solicitud.centro.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    direccionErrors() {
      const errors = [];
      if (!this.$v.solicitud.direccion.$dirty) return errors;
      !this.$v.solicitud.direccion.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    empresaErrors() {
      const errors = [];
      if (!this.$v.solicitud.empresa.$dirty) return errors;
      !this.$v.solicitud.empresa.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    departamentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.departamento.$dirty) return errors;
      !this.$v.solicitud.departamento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    puestoErrors() {
      const errors = [];
      if (!this.$v.solicitud.puesto.$dirty) return errors;
      !this.$v.solicitud.puesto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    }
  },
  mounted() {
    this.setDates();
    this.fetchSolicitudes();
    this.ws("get", "check").then(res => {
      if (res.ok) {
        this.roles = res.data.roles;
      }
    });
    const id = this.$route.params.idsolicitud;
    if (id) {
      this.showDetailRep(id)
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    formatMoney(v) {
      if (v === null || v === undefined || v === '') return '';
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : '';
    },
    print() {
      this.loading = true;
      // Abrir ventana inmediatamente para evitar bloqueo de popup
      const pdfWindow = window.open("", "_blank");
      // Mostrar página de carga mientras se genera el PDF
      if (pdfWindow) {
        pdfWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Generando PDF...</title>
            <style>
              body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
              .loader-container { text-align: center; }
              .spinner { border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
              @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; }
            </style>
          </head>
          <body>
            <div class="loader-container">
              <div class="spinner"></div>
              <h2>Generando PDF</h2>
              <p>Por favor espere, esto puede tomar unos segundos...</p>
            </div>
          </body>
          </html>
        `);
        pdfWindow.document.close();
      }
      let data = {
        idsolicitud: this.idsolicitud_comprobacion,
      };
      this.ws("get", "impresionDetalleSolicitudComprobacionRepresentacion", data)
        .then(res => {
          if (res.ok) {
            this.confirmClose();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
            // Redirigir la ventana al PDF
            if (pdfWindow) {
              pdfWindow.location.href = res.data;
            } else {
              window.open(res.data, "_blank");
            }
          } else {
            // Cerrar ventana si hubo error
            if (pdfWindow) {
              pdfWindow.close();
            }
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async descargarTodo() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.descargarComprobantesComprobacionRepresentacion.replace(
          ":id",
          this.idsolicitud_comprobacion
        );

        const response = await axios.get(url, { headers, responseType: "blob" });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Comprobantes-Comprobacion-Reposicion-${this.idsolicitud_comprobacion}.zip`;
        link.click();
        window.URL.revokeObjectURL(link.href);

      } catch (err) {
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
        console.error("Error al descargar comprobantes:", err);
      } finally {
        this.loading = false;
      }
    },
    removeElement() {
      this.questionFac = false;
      this.facturas.detalle.splice(this.detalleFactura.index, 1);
      this.updateTotales()
      this.dialogDetFac = false;
    },
    downloadDocument(doc) {
      let nombre = this.detalleFactura[doc].nombre;
      let data = this.detalleFactura[doc].data;

      // Si data es un objeto File (binario)
      if (data instanceof File) {
        const url = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombre || data.name;
        link.click();
        URL.revokeObjectURL(url);
      }
      // Si data es un string base64
      else if (data !== null && data !== "") {
        let mimetype = data.split(";")[0].split(":")[1];
        download(data, nombre, mimetype);
      }
      // Si no hay datos
      else {
        this.alert = true
        this.error = true;
        this.msgError = "El documento no se encuentra disponible";
      }
    },
    closeDetailFac() {
      this.detalleFactura = {
        index: "",
        tipo_gasto: null,
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        razon_social: "",
        rfc: "",
        no_factura: "",
        fecha_timbrado: "",
        proveedor: "",
        folio: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      },
        this.dialogDetFac = false;
    },
    showDetailFac(idx) {
      this.detalleFactura = {
        index: "",
        tipo_gasto: null,
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        razon_social: "",
        rfc: "",
        no_factura: "",
        fecha_timbrado: "",
        proveedor: "",
        folio: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      },
        this.detalleFactura.index = idx;
      console.log(this.facturas.detalle[
        idx])
      this.detalleFactura.proveedor = this.facturas.detalle[
        idx
      ].proveedor;
      this.detalleFactura.tipo_gasto = this.facturas.detalle[
        idx
      ].tipo_gasto;
      if (this.facturas.detalle[idx].pdf) {
        this.detalleFactura.pdf.nombre = this.facturas.detalle[
          idx
        ].pdf.nombre;
        this.detalleFactura.pdf.data = this.facturas.detalle[
          idx
        ].pdf.data;
      }
      if (this.facturas.detalle[idx].xml) {
        this.detalleFactura.xml.nombre = this.facturas.detalle[
          idx
        ].xml.nombre;
        this.detalleFactura.xml.data = this.facturas.detalle[
          idx
        ].xml.data;
      }
      if (this.facturas.detalle[idx].foto) {
        this.detalleFactura.foto.nombre = this.facturas.detalle[
          idx
        ].foto.nombre;
        this.detalleFactura.foto.data = this.facturas.detalle[
          idx
        ].foto.data;
      }
      this.detalleFactura.concepto = this.catalogos.conceptos.filter(
        concepto => {
          return concepto.id == this.facturas.detalle[idx].idcat_concepto;
        }
      )[0].descripcion;
      this.detalleFactura.folio = this.facturas.detalle[
        idx
      ].uuid;
      this.detalleFactura.rfc = this.facturas.detalle[idx].rfc;
      this.detalleFactura.no_factura = this.facturas.detalle[
        idx
      ].no_factura;
      this.detalleFactura.fecha_timbrado = this.facturas.detalle[
        idx
      ].fecha_timbrado;
      this.detalleFactura.subtotal = this.facturas.detalle[
        idx
      ].subtotal;
      this.detalleFactura.descuento = this.facturas.detalle[
        idx
      ].descuento;
      this.detalleFactura.iva = this.facturas.detalle[idx].iva;
      this.detalleFactura.total = this.facturas.detalle[idx].total;
      this.detalleFactura.subtotal = parseFloat(this.detalleFactura.subtotal)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.descuento = parseFloat(this.detalleFactura.descuento)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.iva = parseFloat(this.detalleFactura.iva)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.total = parseFloat(this.detalleFactura.total)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.id_comprobante = this.facturas.detalle[idx].idcomprobante_representacion || this.facturas.detalle[idx].id_comprobante;
      this.detalleFactura.idcat_concepto = this.facturas.detalle[idx].idcat_concepto;
      this.dialogDetFac = true;
    },
    async saveNewCom() {
      this.$v.solicitud.comprobantes.nueva.$touch();
      if (this.$v.solicitud.comprobantes.nueva.$invalid) {
        return
      }

      // Verificar que los archivos fueron cargados correctamente (esperamos base64 strings)
      let pdf_data = this.solicitud.comprobantes.nueva.pdf.data;
      let xml_data = this.solicitud.comprobantes.nueva.xml.data;
      let foto_data = this.solicitud.comprobantes.nueva.foto.data;

      // Validación según tipo de gasto
      if (this.solicitud.comprobantes.nueva.tipo_gasto == 'deducible') {
        // Para deducible: PDF y XML son obligatorios
        if (!pdf_data) {
          this.alert = true
          this.error = true;
          this.msgError = "Archivo PDF es requerido para gasto deducible";
          this.loading = false
          return false
        }
        if (!xml_data) {
          this.alert = true
          this.error = true;
          this.msgError = "Archivo XML es requerido para gasto deducible";
          this.loading = false
          return false
        }
      } else {
        // Para no deducible: Al menos PDF o FOTO es obligatorio
        if (!pdf_data && !foto_data) {
          this.alert = true
          this.error = true;
          this.msgError = "Debe cargar al menos PDF o FOTO para gasto no deducible";
          this.loading = false
          return false
        }
      }

      let comprobante = {
        tipo_gasto: this.solicitud.comprobantes.nueva.tipo_gasto,
        idcat_centro_costo: this.solicitud.centro.idcat_centro_costo,
        idcat_concepto: this.solicitud.comprobantes.nueva.concepto,
        idcat_detalle_nodeducible: this.solicitud.comprobantes.nueva.detalleNoDeducible,
        proveedor: this.solicitud.comprobantes.nueva.proveedor,
        pdf: {
          nombre: this.solicitud.comprobantes.nueva.pdf.nombre,
          data: this.solicitud.comprobantes.nueva.pdf.data
        },
        xml: {
          nombre: this.solicitud.comprobantes.nueva.xml.nombre,
          data: this.solicitud.comprobantes.nueva.xml.data
        },
        foto: {
          nombre: this.solicitud.comprobantes.nueva.foto.nombre,
          data: this.solicitud.comprobantes.nueva.foto.data
        },
        rfc: this.solicitud.comprobantes.nueva.rfc,
        folio: this.solicitud.comprobantes.nueva.folio,
        uuid: this.solicitud.comprobantes.nueva.uuid,
        fecha_timbrado: this.solicitud.comprobantes.nueva.fecha_timbrado,
        subtotal: parseFloat(
          parseFloat(this.solicitud.comprobantes.nueva.subtotal).toFixed(2)
        ) || 0,
        descuento: parseFloat(
          parseFloat(this.solicitud.comprobantes.nueva.descuento).toFixed(2)
        ) || 0,
        iva: parseFloat(
          parseFloat(this.solicitud.comprobantes.nueva.iva).toFixed(2)
        ) || 0,
        total: parseFloat(
          parseFloat(this.solicitud.comprobantes.nueva.total).toFixed(2)
        )
      };
      this.facturas.detalle.push(comprobante)
      console.log("this.facturas.detalle", this.facturas.detalle)
      this.closeNewCom()
      this.updateTotales()
    },

    updateTotales() {
      let subtotal = 0;
      let iva = 0;
      let total = 0;
      for (let f of this.facturas.detalle) {
        subtotal += Number(f.subtotal)
        iva += Number(f.iva)
        total += Number(f.total)
      }
      this.facturas.subtotal = subtotal
      this.facturas.iva = iva
      this.facturas.total = total
    },
    prepareForm(data) {
      this.catalogos.centros = data.catalogos.centros;
      this.catalogos.conceptos = data.catalogos.conceptos;
      this.catalogos.conceptos_sat = data.catalogos.conceptos_sat;
      this.catalogos.cajas_chicas = data.catalogos.cajas_chicas;
      this.ws("post", "obtenerCatalogo", { tableName: 'cat_detalles_nodeducibles' })
        .then(res => {
          if (res.ok) {
            this.catalogos.detallesNoDeducibles = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })

      this.ws("post", "obtenerCatalogo", { tableName: 'cat_puestos' })
        .then(res => {
          if (res.ok) {
            this.catalogos.puestos = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })


      this.ws("post", "obtenerCatalogo", { tableName: 'cat_departamentos' })
        .then(res => {
          if (res.ok) {
            this.catalogos.departamentos = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })

      this.ws("post", "obtenerCatalogo", { tableName: 'cat_direcciones' })
        .then(res => {
          if (res.ok) {
            this.catalogos.direcciones = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })

      this.ws("post", "obtenerCatalogo", { tableName: 'cat_empresas' })
        .then(res => {
          if (res.ok) {
            this.catalogos.empresas = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })


      this.ws("post", "obtenerCatalogo", { tableName: 'cat_centros_costos' })
        .then(res => {
          if (res.ok) {
            this.catalogos.centros = res.data.datos
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })

    },
    closeNewCom() {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: "",
      };
      this.solicitud.comprobantes.nueva = {
        tipo_gasto: "deducible",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        no_factura: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.dialogNewCom = false;
    },
    resetCamposNuevoComprobante() {
      this.$v.solicitud.comprobantes.nueva.$reset();
      this.solicitud.comprobantes.nueva = {
        ...this.solicitud.comprobantes.nueva,
        concepto: "",
        detalleNoDeducible: null,
        rfc: "",
        proveedor: "",
        folio: "",
        uuid: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.color.pdf = "";
      this.color.xml = "";
      this.color.foto = "";

      if (this.solicitud.comprobantes.nueva.tipo_gasto === 'no_deducible') {
        const porDefinir = this.catalogos.conceptos.find(c => c.cuenta == "12202" && c.subcuenta == "000000")
          || this.catalogos.conceptos.find(c => c.cuenta == "12204" && c.subcuenta == "000000");
        if (porDefinir) {
          this.solicitud.comprobantes.nueva.concepto = porDefinir.id;
        }
      }

    },
    async onSeleccionarSolicitud(value) {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.representacionSolicitudesDetalle.replace(
          ":id",
          value
        );
        const { data } = await axios.get(url, { headers });
        this.solicitud.tipo_gasto = data.tipo_gasto
        if (this.solicitud.tipo_gasto == 'atencion_personal') {
          this.solicitud.tipo_atencion = data.subtipo_atencion
        }
        this.solicitud.tipo_pago = data.tipo_pago
        this.solicitud.banco = data.banco
        this.solicitud.cuenta = data.numero_cuenta
        this.solicitud.tarjeta = data.numero_tarjeta
        this.solicitud.clabe = data.referencia_interbancaria
        this.solicitud.nombre = data.nombre_responsable

        const puesto = this.catalogos.puestos.find(
          e => e.descripcion === data.puesto
        );
        if (puesto) {
          this.solicitud.puesto = puesto.idcat_puesto;
        }
        this.solicitud.departamento = data.idcat_departamento
        this.solicitud.direccion = data.idcat_direccion
        this.solicitud.empresa = data.idcat_empresa
        this.solicitud.centro = data.idcat_centro_costo
        this.solicitud.asistentes = data.numero_asistentes
        this.solicitud.importe = data.importe
        this.solicitud.observaciones = data.observaciones
        this.solicitud.importe_letra = data.importe_letra
        this.idsolicitud_gasto_representacion = value
        this.enableAdd = true
        this.facturas.detalle = []
        this.updateTotales()
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {
        this.loading = false;
      }
    },
    mapTipo(value) {
      const map = {
        deducible: 'DEDUCIBLE',
        no_deducible: 'NO DEDUCIBLE'
      }
      return map[value] || value
    },
    mapTipoGasto(value) {
      const map = {
        representacion: 'Gastos de representación',
        atencion_personal: 'Atención al personal'
      }
      return map[value] || value
    },
    mapTipoPago(value) {
      const map = {
        transferencia: 'Transferencia',
        cheque: 'Cheque'
      }
      return map[value] || value
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatSolicitud(item) {
      if (!item) return '';
      return `${item.idsolicitud_gasto_representacion} - ${this.mapTipoGasto(item.tipo_gasto)} - ${this.formatCurrency(item.importe)}`;
    },
    reset() {
      this.solicitud = {
        tipo_pago: null,
        comprobantes: {
          importe_total: 0,
          no_comprobantes: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          nueva: {
            tipo_gasto: "deducible",
            pdf: { nombre: "", data: null },
            xml: { nombre: "", data: null },
            foto: { nombre: "", data: null },
            centro: null,
            concepto: "",
            rfc: "",
            proveedor: "",
            folio: "",
            uuid: "",
            no_comprobante: "",
            fecha_timbrado: "",
            subtotal: "",
            descuento: "",
            iva: "",
            total: ""
          },
          detalle: []
        }
      };
      this.$v.$reset(); // Resetea validaciones
    },
    centroText(item) {
      return `${item.idexterno} - ${item.descripcion}`;
    },
    async showDetailRep(id) {
      this.idsolicitud_comprobacion = id
      this.loading = true;
      this.showDetail = true
      this.firmas = []
      try {
        this.ws("get", "detalleUsuario")
          .then(res => {
            if (res.ok) {
              this.prepareForm(res.data);
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.representacionComprobacionSolicitudDetalle.replace(
          ":id",
          id
        );
        const { data } = await axios.get(url, { headers });
        this.solicitudes_gastos = [
          data.idsolicitud_gasto_representacion
        ]
        await this.onSeleccionarSolicitud(data.idsolicitud_gasto_representacion.idsolicitud_gasto_representacion)
        this.sol_gastos = data.idsolicitud_gasto_representacion.idsolicitud_gasto_representacion
        this.firmas = data.firmas
        this.facturas.detalle = data.comprobantes
        this.dialogNewReq = true
        this.enableAdd = false
        this.updateTotales()
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {
        this.loading = false;
      }
    },
    setDates() {
      this.tipoGasto = "0"
      const hoy = new Date();
      const tresMesesAntes = new Date(hoy.setMonth(hoy.getMonth() - 3));
      this.fechaInicio = tresMesesAntes.toISOString().slice(0, 10);
      this.fechaFin = new Date().toISOString().slice(0, 10);
    },
    async fetchSolicitudes() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        let request = {
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin
        }
        if (this.tipoGasto != "0") {
          request.tipo = this.tipoGasto
        }
        const { data } = await axios.post(
          services.routes.representacionComprobacionSolicitudesList,
          request,
          { headers }
        );
        this.solicitudes = data;
      } catch (err) {
        console.error("Error al cargar solicitudes:", err);
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.fetchSolicitudes();
    },
    formatDateTable(date) {
      if (!date) return "";
      const options = {
        timeZone: "America/Mexico_City",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      };
      const formatter = new Intl.DateTimeFormat("es-MX", options);
      const formatted = formatter.format(new Date(date));
      const [dia, mes, anio, hora] = formatted.replace(",", "").split(" ");
      const mesUpper = mes.toUpperCase();
      return `${dia}-${mesUpper}-${anio} ${hora}`;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = n => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    formatCurrency(amount) {
      if (isNaN(amount)) return "$0.00";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },
    async newSol() {
      this.facturas.detalle = []
      this.enableAdd = false
      this.showDetail = false
      this.updateTotales()
      this.sol_gastos = null
      this.dialogNewRep = true
      this.loading = true;
      this.firmas = []
      try {

        this.ws("get", "detalleUsuario")
          .then(res => {
            if (res.ok) {
              this.prepareForm(res.data);
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })

        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.representacionSolicitudesList + "?estatus=5"
        const { data } = await axios.get(url, { headers });
        this.solicitudes_gastos = data
        this.dialogNewReq = true;
      } catch (err) {
        console.error("Error al catalogos:", err);
      } finally {
        this.loading = false;
      }
    },
    checkQuestionReq() {
      if (this.facturas.detalle.length == 0) {
        this.alert = true;
        this.msgError = "Debe cargar al menos 1 comprobante.";
        return;
      }
      this.questionReq = true;
    },
    async saveSol() {
      this.false = true;
      this.questionReq = false;
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        let data = {
          tipo_pago: this.solicitud.tipo_pago,
          idsolicitud_gasto_representacion: this.idsolicitud_gasto_representacion,
          comprobantes: this.facturas.detalle,
        };
        console.log("Data a enviar:", data);
        let res = await axios.post(services.routes.representacionComprobacionSolicitudCreate, data, {
          headers
        });
        this.reset();
        this.close();
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud guardada correctamente";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
        this.refresh()
      }
    },
    confirmClose() {
      this.reset();
      this.dialogNewReq = false;
      this.confirmCloseReq = false;
    },
    close() {
      this.$v.$reset();
      this.confirmCloseReq = false;
      this.dialogNewReq = false;
    },
    async readFile(doc) {
      this.alert = false;
      let fr = new FileReader();
      let file = this.$refs[doc].files;
      if (!file || !file[0]) return;
      const archivo = file[0];
      const nombreArchivo = archivo.name.toLowerCase();

      if (doc === "pdf" && !nombreArchivo.endsWith(".pdf")) {
        this.alert = true;
        this.msgError = "El archivo debe ser un PDF válido.";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      if (doc === "xml" && !nombreArchivo.endsWith(".xml")) {
        this.alert = true;
        this.msgError = "El archivo debe ser un XML válido.";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      if (doc === "foto" && !(/\.(jpg|jpeg|png|gif|bmp)$/i.test(nombreArchivo))) {
        this.alert = true;
        this.msgError = "El archivo debe ser una imagen válida (JPG, PNG, GIF, BMP).";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      const yaExiste = this.facturas.detalle.some(comp => {
        if (doc === 'pdf' && comp.pdf && comp.pdf.nombre) {
          return comp.pdf.nombre.toLowerCase() === nombreArchivo;
        }
        if (doc === 'xml' && comp.xml && comp.xml.nombre) {
          return comp.xml.nombre.toLowerCase() === nombreArchivo;
        }
        if (doc === 'foto' && comp.foto && comp.foto.nombre) {
          return comp.foto.nombre.toLowerCase() === nombreArchivo;
        }
        return false;
      });
      if (yaExiste) {
        this.alert = true;
        this.msgError = `Ya existe un comprobante con el archivo ${doc.toUpperCase()} "${nombreArchivo}"`;
        this.$refs[doc].value = null;
        this.color[doc] = '';
        return;
      }

      let size = file[0].size;
      let name = file[0].name;
      if (size <= 10000000) {
        fr.onload = () => {
          this.color[doc] = "success";
          this.solicitud.comprobantes.nueva[doc].nombre = name
          this.solicitud.comprobantes.nueva[doc].data = fr.result
          if (doc === "xml") {
            this.loading = true;
            const formData = new FormData();
            formData.append("xml", file[0]);
            const jwt = this.$session.get("jwt");
            axios
              .post(services.routes.representacionProcesarXML, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${jwt}`
                }
              })
              .then(res => {
                let data = res.data;
                this.solicitud.comprobantes.nueva.rfc = data.rfc_emisor
                this.solicitud.comprobantes.nueva.proveedor = data.proveedor
                this.solicitud.comprobantes.nueva.folio = data.folio
                this.solicitud.comprobantes.nueva.uuid = data.uuid
                this.solicitud.comprobantes.nueva.subtotal = Number(data.subtotal) + Number(data.totalIEPS)
                this.solicitud.comprobantes.nueva.iva = data.iva
                this.solicitud.comprobantes.nueva.descuento = data.descuento
                this.solicitud.comprobantes.nueva.total = data.total
                this.solicitud.comprobantes.nueva.fecha_timbrado = data.fecha_timbrado
                this.solicitud.comprobantes.nueva.totalIEPS = data.totalIEPS
                let concepto = data.conceptos[0]
                let cve = concepto.clave_prod_serv
                let cuenta = "";
                let subcuenta = "";
                for (let i = 0; i < this.catalogos.conceptos_sat.length; i++) {
                  if (this.catalogos.conceptos_sat[i].clave == cve) {
                    cuenta = this.catalogos.conceptos_sat[i].cuenta;
                    subcuenta = this.catalogos.conceptos_sat[i].subcuenta;
                    for (let j = 0; j < this.catalogos.conceptos.length; j++) {
                      if (
                        this.catalogos.conceptos[j].cuenta == cuenta &&
                        this.catalogos.conceptos[j].subcuenta == subcuenta
                      ) {
                        this.solicitud.comprobantes.nueva.concepto = this.catalogos.conceptos[
                          j
                        ].id;
                      }
                    }
                  }
                }
                if (this.solicitud.comprobantes.nueva.concepto == '') {
                  const porDefinir = this.catalogos.conceptos.find(c => c.cuenta == "12202" && c.subcuenta == "000000")
                    || this.catalogos.conceptos.find(c => c.cuenta == "12204" && c.subcuenta == "000000");
                  if (porDefinir) {
                    this.solicitud.comprobantes.nueva.concepto = porDefinir.id;
                  }
                }
                this.loading = false;
              })
              .catch(err => {
                console.log(err)
                this.loading = false;
                this.alert = true;
                if (err && err.response && err.response.data) {
                  this.msgError =
                    err.response.data.message || "Error del servidor";
                } else {
                  this.msgError = err.message || "Error desconocido";
                }
                this.$refs[doc].value = null;
                this.color[doc] = '';
              });
          }
        };
        fr.onerror = () => {
          this.color[doc] = "";
          this.alert = true;
          this.msgError = "El archivo no fue leído correctamente";
          this.loading = false;
        };
        // Convertir TODOS los archivos a base64 para que se puedan serializar en JSON
        fr.readAsDataURL(file[0]);
      } else {
        this.alert = true;
        this.msgError = "El archivo ha excedido el límite permitido (10 MB)";
        this.loading = false;
      }

    },
    async abrirActualizarConcepto() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const response = await axios.get(services.routes.getConceptos, { headers });
        if (response.data) {
          this.conceptosDisponibles = response.data;
          this.nuevoConcepto = this.detalleFactura.idcat_concepto || null;
          this.dialogActualizarConcepto = true;
        } else {
          this.alert = true;
          this.msgError = "Error al obtener conceptos";
        }
      } catch (err) {
        this.alert = true;
        this.msgError = (err.response && err.response.data && err.response.data.message) || "Error al obtener conceptos";
      } finally {
        this.loading = false;
      }
    },
    closeActualizarConcepto() {
      this.dialogActualizarConcepto = false;
      this.nuevoConcepto = null;
      this.conceptosDisponibles = [];
    },
    async updateConcepto() {
      if (this.roles.indexOf("administrador") >= 0) {
        if (this.nuevoConcepto) {
          this.loading = true;
          try {
            const jwt = this.$session.get("jwt");
            const headers = { Authorization: "Bearer " + jwt };
            const data = {
              tipo: "gastos_representacion_comprobacion",
              id_comprobante: this.detalleFactura.id_comprobante,
              idcat_concepto: this.nuevoConcepto,
              id_solicitud: this.idsolicitud_comprobacion
            };
            const response = await axios.post(services.routes.updateConcepto, data, { headers });
            if (response.data) {
              this.closeActualizarConcepto();
              this.dialogDetFac = false;
              this.dialogNewReq = false;
              this.refresh();
              this.success = true;
              this.msgSuccess = response.data.mensaje || "Concepto actualizado correctamente";
            } else {
              this.alert = true;
              this.msgError = response.data.message || "Error al actualizar el concepto";
            }
          } catch (err) {
            this.alert = true;
            this.msgError = (err.response && err.response.data && err.response.data.message) || "Error al actualizar el concepto";
            console.error(err);
          } finally {
            this.loading = false;
          }
        } else {
          this.alert = true;
          this.msgError = "Debe seleccionar un concepto disponible";
        }
      } else {
        this.alert = true;
        this.msgError = "No cuenta con los permisos necesarios para realizar esta acción";
      }
    },
  }
};
</script>

<style scoped>
.v-text-field {
  max-width: 85% !important;
  /* puedes ajustar a 70%, 60% según te guste */
  margin-left: auto;
  margin-right: auto;
}

.deposito-field {
  margin-left: 0 !important;
  /* Alinea a la izquierda */
  margin-right: auto !important;
}

/* inputs/selecciones más angostos y centrados */
.titulo-centrado {
  width: 100%;
  text-align: center;
}

.mt-neg {
  margin-top: 10px;
}

.no-gutters {
  margin: 0 !important;
}

.no-gutters>.v-flex {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.firmas-titulo {
  text-align: center;
  margin-bottom: 8px;
}

/* Hacer que el v-list mida lo mismo que los v-text-field */
.firmas-list {
  max-width: 85%;
  /* 🔁 usa el mismo % que tus .v-text-field */
  margin-left: auto;
  margin-right: auto;
}

/* (Opcional) Alinear borde visual con inputs reduciendo padding lateral */
.firmas-list .v-list__tile,
.firmas-list .v-list-tile {
  padding-left: 0;
  padding-right: 0;
}
</style>